import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import {
  CREATE_NOTE_FAILURE,
  CREATE_NOTE_REQUEST,
  CREATE_NOTE_SUCCESS
} from "../types";
import { addEntities } from "../../entities";

export default (debtorId, note, attachment) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    dispatch(createAction(CREATE_NOTE_REQUEST)({}));
    const response = await api.debtors.createNote(debtorId, note, attachment);

    const data = normalize(response, schema.notes);

    dispatch(addEntities(data.entities));
    dispatch(
      createAction(CREATE_NOTE_SUCCESS)({
        [debtorId]: [data.result]
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(CREATE_NOTE_FAILURE)(err));
    throw err;
  }
};
